let analyticsInitialized = false;

const isBrowser = typeof window !== "undefined";

const getMeasurementId = () => process.env.REACT_APP_GA_MEASUREMENT_ID;

const ensureGtag = () => {
  const measurementId = getMeasurementId();

  if (!isBrowser || !measurementId) {
    return null;
  }

  if (!window.gtag) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  return window.gtag;
};

const loadGoogleAnalytics = () => {
  const measurementId = getMeasurementId();

  if (!isBrowser || !measurementId || document.getElementById("ga4-script")) {
    return;
  }

  const script = document.createElement("script");
  script.id = "ga4-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);
};

const initAnalytics = () => {
  const measurementId = getMeasurementId();

  if (!isBrowser || analyticsInitialized || !measurementId) {
    return;
  }

  const gtag = ensureGtag();

  if (!gtag) {
    return;
  }

  analyticsInitialized = true;
  loadGoogleAnalytics();
  window.gtag("consent", "default", {
    analytics_storage: "granted",
  });

  window.gtag("js", new Date());
  window.gtag("config", measurementId, {
    send_page_view: false,
  });
};

const trackEvent = (eventName, params = {}) => {
  const gtag = ensureGtag();

  if (!gtag) {
    return;
  }

  gtag("event", eventName, params);
};

const trackPageView = (location = window.location.href) => {
  const gtag = ensureGtag();

  if (!gtag) {
    return;
  }

  gtag("event", "page_view", {
    page_location: location,
    page_title: document.title || "Portfolio",
  });
};

export { initAnalytics, trackEvent, trackPageView };
